import { IUserSubscriptionStore } from './types';

export const getUserSubscription = (store: IUserSubscriptionStore) => store.subscription;
export const getSetUserSubscription = (store: IUserSubscriptionStore) => store.setSubscription;

export const getIsSubscriptionLoading = (store: IUserSubscriptionStore) => store.isSubscriptionLoading;
export const getSetIsSubscriptionLoading = (store: IUserSubscriptionStore) => store.setIsSubscriptionLoading;
